<template>
  <svg
    width="41"
    height="41"
    viewBox="0 0 41 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.291016"
      y="0.75"
      width="40"
      height="40"
      rx="8"
      :fill="$primaryColor"
    />
    <path
      d="M24.0629 10.75H17.2057C14.681 10.75 12.6343 12.7398 12.6343 15.1944V24.0833"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M17.3207 29.0128L16.7712 29.4465L17.3207 29.0128C17.0791 28.7066 16.9277 28.3017 16.8466 27.6031C16.7638 26.889 16.7627 25.9593 16.7627 24.6395V20.1951C16.7627 18.8752 16.7638 17.9456 16.8466 17.2315C16.9277 16.5329 17.0791 16.128 17.3207 15.8218C17.465 15.639 17.6336 15.4749 17.8227 15.3339C18.1429 15.095 18.5678 14.9455 19.2936 14.8659C20.0321 14.785 20.9923 14.784 22.3485 14.784C23.7046 14.784 24.6648 14.785 25.4034 14.8659C26.1291 14.9455 26.5541 15.095 26.8742 15.3339L27.2879 14.7794L26.8742 15.3339C27.0633 15.4749 27.232 15.639 27.3762 15.8218C27.6178 16.128 27.7693 16.5329 27.8503 17.2315C27.9331 17.9456 27.9342 18.8752 27.9342 20.1951V24.6395C27.9342 25.9593 27.9331 26.889 27.8503 27.6031C27.7693 28.3017 27.6178 28.7066 27.3762 29.0128C27.232 29.1956 27.0633 29.3597 26.8742 29.5007C26.5541 29.7395 26.1291 29.8891 25.4034 29.9687C24.6648 30.0496 23.7046 30.0506 22.3485 30.0506C20.9923 30.0506 20.0321 30.0496 19.2936 29.9687C18.5678 29.8891 18.1429 29.7395 17.8227 29.5007C17.6336 29.3597 17.465 29.1956 17.3207 29.0128Z"
      stroke="white"
      stroke-width="1.4"
    />
  </svg>
</template>
<script>
export default {
  props: {
    fill: {
      type: String,
      default: () => 'white'
    }
  }
}
</script>
